import React, { useCallback } from 'react';
import { useIntl } from 'react-intl-next';
import { di } from 'react-magnetic-di';
import { DatePicker } from '@atlaskit/datetime-picker';
import { Box, xcss } from '@atlaskit/primitives';
import { useActions } from '../../../../../controllers/conversation-store';
import type { RequestTypeField } from '../../../../../services/request-type-fields-service/types';

import messages from './messages';

export const DatePickerAppendix = ({ field }: { field: RequestTypeField }) => {
    di(useActions);
    const { addJiraFieldMessage } = useActions();
    const { formatMessage, formatDate } = useIntl();

    const handleDateSelect = useCallback(
        (date: string) => {
            addJiraFieldMessage(field.fieldId, date, formatDate(date));
        },
        [addJiraFieldMessage, field, formatDate]
    );

    return (
        <Box xcss={datePickerWrapper}>
            <DatePicker
                onChange={handleDateSelect}
                testId="virtual-agent-conversation-date-picker"
                placeholder={formatMessage(messages.datePickerPlaceholderNonFinal)}
            />
        </Box>
    );
};

const datePickerWrapper = xcss({
    flexGrow: '1',
    minWidth: 'size.1000',
    marginRight: 'space.100',
});
